import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import  './Resources/Actions.css';
import './App.css';

export default function Ledger(){
    const navigate = useNavigate();
    const location = useLocation();
    const [rlist,setRlist]= useState([]);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const {cusid,cusname,place,loanlist,custom} = location.state;
    var ldate = loanlist[0].LoanDate.slice(0,10);
    var dat = new Date().toLocaleDateString().slice(0,10);
    
    console.log(dat);
     

   useEffect(()=>{
        fetch(API_URL+"api/Payment/GetPayments?id=" + loanlist[0].LoanNo)
        .then(response => response.json())
        .then(data => {setRlist(data)});

        
    },[]);

    
    const Total = rlist.length > 0 ? rlist.reduce((tot,el)=>tot+ el.RAmount,0) : 0;
    console.log(rlist);
    return(
        <>
        <Navbar/>
        <div style={{height:"30px", width:"100%",paddingTop:"10px",paddingLeft:"10px",backgroundColor:"blue",color:"white",textAlign:"left"}}>Ledger</div>
            
        <div style={{backgroundColor:"goldenrod",height:"30px",width:"100%",textAlign:"center",zIndex:-1,fontWeight:"bolder"}}>{cusname}</div>

        <div style={{backgroundColor:"lightskyblue",fontWeight:"bolder",  height:"30px",width:"100%",textAlign:"center",zIndex:-1}}>Loan Number: {loanlist[0].AccountNo} </div>
         
            <table style={{width:"100%",marginBottom:"40px",backgroundColor:"lightskyblue"}}>
                <tr>
                    <th>Date</th>
                    <th>R.No</th>
                    <th>Loan</th>
                    <th>Fine</th>
                    <th>Paid</th>
                </tr>
                <tr>
                 <td> {ldate.slice(8,10)}-{ldate.slice(5,7)}-{ldate.slice(0,4)} </td>
                 <td></td>
                 <td> {loanlist[0].LoanAmount}</td>
                 <td></td>
                 <td></td>
                </tr>
                {rlist.map(cus => {return(<tr>
                    <td>{cus.RDate.slice(8,10)}-{cus.RDate.slice(5,7)}-{cus.RDate.slice(0,4)}</td>
                    <td>{cus.ReceiptNo}</td>
                    <td></td>
                    <td>{cus.RFine}</td>
                    <td>{cus.RAmount}</td>
                </tr>)})}
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                
                <tr>
                    <td></td>
                    
                    <td style={{fontWeight:"bolder"}}>Total</td>
                    <td style={{fontWeight:"bolder"}}>{loanlist[0].LoanAmount}</td>
                    <td></td>
                    <td style={{fontWeight:"bolder"}}>{Total}</td>
                </tr>
                <tr>

                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{fontWeight:"bolder"}}>Balance</td>
                    <td style={{fontWeight:"bolder"}}>{loanlist[0].LoanAmount-Total}</td>
                </tr>
            </table>
 
        <button type="button" className="backbutton" onClick={()=>{navigate('/actions', {state:{cusid,cusname,place,custom}})}}>Back</button>

        </>
    )

}